import React from 'react';
import {useFormikContext} from 'formik';
import {useSelector} from 'react-redux';

import {Store} from 'src/types/store';
import {EducationPhase} from 'src/types/enums';
import {WorkExperienceForm as WorkExperienceFormType} from 'shared/portfolio/components/work-experiences/work-experience-form-wrapper';

import Label from 'shared/components/label';
import FormikTextInput from 'src/components/inputs/formik-text-input';
import FormikDatePicker from 'src/components/formik-date-picker';
import FormikCheckbox from 'src/components/formik-checkbox';
import FormikTextArea from 'src/components/formik-text-area';

const WorkExperienceForm = () => {
  const formik = useFormikContext<WorkExperienceFormType>();
  const educationPhase = useSelector((state: Store) => state.student?.educationPhase);
  const lastX = educationPhase === EducationPhase.HIGH_SCHOOL ? 6 : 30;

  return (
    <>
      <legend className="shared-required-legend"></legend>

      <Label required>
        What was your title?
        <FormikTextInput
          name="role"
          autoFocus={formik.values.new}
          placeholder="e.g. Lifeguard"
          required
        />
      </Label>

      <Label required>
        Where did you work?
        <FormikTextInput name="place" placeholder="e.g. YMCA" required />
      </Label>

      <FormikDatePicker
        dayLabel="Start day"
        dayName="startDay"
        monthLabel="Start month"
        monthName="startMonth"
        yearLabel="Start year"
        yearName="startYear"
        lastX={lastX}
        required
      />

      {!formik.values.currentWorkplace && (
        <FormikDatePicker
          dayLabel="End day"
          dayName="endDay"
          monthLabel="End month"
          monthName="endMonth"
          yearLabel="End year"
          yearName="endYear"
          lastX={lastX}
          required={!formik.values.currentWorkplace}
        />
      )}

      <FormikCheckbox
        name="currentWorkplace"
        label="I currently work here."
        className="mt-12"
        onChange={(e) => {
          formik.setValues({
            ...formik.values,
            currentWorkplace: e.target.checked,
            endDay: null,
            endMonth: null,
            endYear: null,
          });
        }}
      />

      <Label required>
        How many hours did you work each week?
        <FormikTextInput
          name="hoursPerWeek"
          type="number"
          placeholder="e.g. 6"
          min={1}
          max={99}
          required
        />
      </Label>

      <Label required>
        What were your responsibilities?
        <FormikTextArea name="responsibilities" required />
      </Label>

      <FormikCheckbox name="paid" className="mt-12" label="This work experience was paid" />

      <FormikCheckbox name="familyService" label="I worked here to help support my family" />
    </>
  );
};

export default WorkExperienceForm;
